import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import {React,useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';


export default function AddCustomerDialog(props) {
    const {open,onClose,idToken,apiDomain}=props;
    const defaultErrors={"fname":"","lname":"","email":"","mobile":"","lang":""};
    const defaultValues={"fname":"","lname":"","email":"","mobile":"","lang":"gr"};
    //const defaultValues={"fname":"1Greek","lname":"Tester","email":"alexisod@gmail.com","mobile":"333","lang":"gr"};
    
    const [inputs,setInputs] = useState(defaultValues);
    const [errors,setErrors] = useState(defaultErrors);
    const [isSaving,setIsSaving] = useState(false);
    const [saveError,setSaveError] = useState("");
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));
      }
    const handleCancel = () => {
        onClose(null);
        resetData();
      };
    const handleClose = () => {
      onClose(null);
      };
    const resetData=()=>{
        setInputs(defaultValues);
        setErrors(defaultErrors);
        setSaveError("");
      }
    const handleSave = async (event) => {
        if(event){
          event.preventDefault();
        }
        const validationErrors = validate(inputs);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors(validationErrors);
        if(noErrors){
          save();
        }
      }

      const save=async ()=>{
        setIsSaving(true);
        //await sleep(1000);
          const params=`/members/add/`;
          fetch(apiDomain+params,{
            "headers":{"id_token":idToken,'Content-Type': 'application/json'},
            method:"post",
            body:JSON.stringify(inputs)
          })
          .then(res => res.text())
          .then(res => JSON.parse(res))
          .then(res => {
            setIsSaving(false);
            let customerExisted=false;
            if(res.existedContact || res.existedPerson){
              setSaveError("Customer exists");
              customerExisted=true;
            }else{
              resetData();
            }
            onClose({customerExisted:customerExisted,"customerId":res.data.contactId,"fullName":res.data.fullName,"email":res.data.email,"mobile":res.data.mobile})
            
        } )
        .catch((error)=>{
            console.log(error);
            setSaveError(error.message);
            setIsSaving(false);
        });
      }


    const validate = (inputs) => {
        //Email errors
       const validationErrors = {};
       if (!inputs.email) {
        validationErrors.email = 'Check Email';
       } else if (
           !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(inputs.email)
       ) {
        validationErrors.email = 'Invalid email address';
       }
       
       if(!inputs.fname){
        validationErrors.fname = 'First name is required'
       }
       if(!inputs.lname){
        validationErrors.lname = 'Surname is required'
       }
       if(!inputs.mobile){
        validationErrors.mobile = 'Mobile # is required'
       }

       return validationErrors;
     }
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    const useStyles = makeStyles((theme) => ({
        root: {
          '& .MuiTextField-root': {
            margin: theme.spacing(1),
          },
          '& .M2uiInput-root': {
            margin: theme.spacing(1),
          }},
          formControl: {
            margin: theme.spacing(1),
          },
          selectEmpty: {
            margin: theme.spacing(1),
          },
        
      }));
    const classes = useStyles();
    return (
        <div>
          <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">New Customer Details</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Register a new customer. Customer will not be added as a club member but will be able to receive invoices.
              </DialogContentText>
              <form className={classes.root} noValidate autoComplete="off">
                <TextField name="fname" onChange={handleInputChange} value={inputs.fname} error={Boolean(errors.fname)} helperText={errors.fname} label="First Name" variant="standard" required fullWidth/>
                <TextField name="lname" onChange={handleInputChange} value={inputs.lname} error={Boolean(errors.lname)} helperText={errors.lname} label="Surname" variant="standard" required fullWidth/>
                <TextField name="email" onChange={handleInputChange} value={inputs.email} error={Boolean(errors.email)} helperText={errors.email} label="email" variant="standard" required fullWidth/>
                <TextField name="mobile" onChange={handleInputChange} value={inputs.mobile} error={Boolean(errors.mobile)} helperText={errors.mobile} label="Mobile #" variant="standard" required fullWidth/>
                <FormControl className={classes.formControl} fullWidth>
                <InputLabel>Preferred Language</InputLabel>
                <Select name="lang" onChange={handleInputChange} value={inputs.lang} fullWidth>
                  <MenuItem value="gr">Greek</MenuItem>
                  <MenuItem value="en">English</MenuItem>
                </Select>
                </FormControl>
              </form> 
              {saveError&&<DialogContentText>
                <Typography color="secondary">{saveError}</Typography>
              </DialogContentText>
              }
            </DialogContent>
            <DialogActions style={{minHeight:60}}>
              {isSaving&&<CircularProgress/>}
              <Button style={{position:'absolute',left:20}} onClick={resetData} color="secondary" size="medium" disabled={isSaving}>Reset</Button>
              <Button onClick={handleCancel} color="primary" size="medium" variant="text"disabled={isSaving}>Cancel</Button>
              <Button onClick={handleSave} color="primary" size="medium"  variant="text" disabled={isSaving}>Save</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
}